import { GET_LIST_BLOG, GET_ID_BLOG } from "../actions/actionBlog";

const initialState = {
    getListBlogResult: false,
    getListBlogLoading: false,
    getListBlogError: false,

    getIdBlogResult: false,
};

const indexReducerBlog = (state = initialState, action) => {
    switch (action.type) {
        case GET_LIST_BLOG:
            return {
                ...state,
                getListBlogResult: action.payload.data,
                getListBlogLoading: action.payload.loading,
                getListBlogError: action.payload.errorMessage,
            };
        case GET_ID_BLOG:
            return {
                ...state,
                getIdBlogResult: action.payload.data,
            };
        default:
            return state;
    }
};

export default indexReducerBlog;
